import cn from "classnames";
import styles from "./Tag.module.scss";

type TagProps = {
  name: string;
  isActive: boolean;
};

export const Tag: RFC<TagProps> = ({ name, isActive }) => {
  return (
    <div className={cn(styles.tagButton, { [styles.active]: isActive })}>
      <div className={cn(styles.name)}>{name}</div>
      <div className={cn(styles.tooltip)}>{name}</div>
    </div>
  );
};
